import { BrowserOptions, browserTracingIntegration } from '@sentry/react';

import environmentConfig, { Environment } from './environment.config';
import { getEnvOrDefault } from './runtime-env';

/**
 * Sentry config.
 */
const sentryConfig: BrowserOptions = {
  enabled: environmentConfig.environment !== Environment.Development,
  dsn: getEnvOrDefault('NEXT_PUBLIC_SENTRY_APP_DNS', ''),
  integrations: [browserTracingIntegration()],
  tracesSampleRate: 1.0,
};

export default sentryConfig;
